import { render } from "./ActivityClosure.vue?vue&type=template&id=4d1f4dc8"
import script from "./ActivityClosure.vue?vue&type=script&lang=js"
export * from "./ActivityClosure.vue?vue&type=script&lang=js"

import "./ActivityClosure.vue?vue&type=style&index=0&id=4d1f4dc8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__